"use strict";

var _slicedToArray = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/inherits");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prosemirror_inputrules_1 = require("prosemirror-inputrules");

var name_to_emoji_json_1 = __importDefault(require("gemoji/name-to-emoji.json"));

var Node_1 = __importDefault(require("./Node"));

var emoji_1 = __importDefault(require("../rules/emoji"));

var Emoji =
/*#__PURE__*/
function (_Node_1$default) {
  _inherits(Emoji, _Node_1$default);

  function Emoji() {
    _classCallCheck(this, Emoji);

    return _possibleConstructorReturn(this, _getPrototypeOf(Emoji).apply(this, arguments));
  }

  _createClass(Emoji, [{
    key: "commands",
    value: function commands(_ref) {
      var type = _ref.type;
      return function (attrs) {
        return function (state, dispatch) {
          var selection = state.selection;
          var position = selection.$cursor ? selection.$cursor.pos : selection.$to.pos;
          var node = type.create(attrs);
          var transaction = state.tr.insert(position, node);
          dispatch(transaction);
          return true;
        };
      };
    }
  }, {
    key: "inputRules",
    value: function inputRules(_ref2) {
      var type = _ref2.type;
      return [new prosemirror_inputrules_1.InputRule(/^\:([a-zA-Z0-9_+-]+)\:$/, function (state, match, start, end) {
        var _match = _slicedToArray(match, 2),
            okay = _match[0],
            markup = _match[1];

        var tr = state.tr;

        if (okay) {
          tr.replaceWith(start - 1, end, type.create({
            "data-name": markup,
            markup: markup
          }));
        }

        return tr;
      })];
    }
  }, {
    key: "toMarkdown",
    value: function toMarkdown(state, node) {
      var name = node.attrs["data-name"];

      if (name) {
        state.write(":".concat(name, ":"));
      }
    }
  }, {
    key: "parseMarkdown",
    value: function parseMarkdown() {
      return {
        node: "emoji",
        getAttrs: function getAttrs(tok) {
          return {
            "data-name": tok.markup.trim()
          };
        }
      };
    }
  }, {
    key: "name",
    get: function get() {
      return "emoji";
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        attrs: {
          style: {
            default: ""
          },
          "data-name": {
            default: undefined
          }
        },
        inline: true,
        content: "text*",
        marks: "",
        group: "inline",
        selectable: false,
        parseDOM: [{
          tag: "span.emoji",
          preserveWhitespace: "full",
          getAttrs: function getAttrs(dom) {
            return {
              "data-name": dom.dataset.name
            };
          }
        }],
        toDOM: function toDOM(node) {
          if (name_to_emoji_json_1.default[node.attrs["data-name"]]) {
            var _text = document.createTextNode(name_to_emoji_json_1.default[node.attrs["data-name"]]);

            return ["span", {
              class: "emoji ".concat(node.attrs["data-name"]),
              "data-name": node.attrs["data-name"]
            }, _text];
          }

          var text = document.createTextNode(":".concat(node.attrs["data-name"], ":"));
          return ["span", {
            class: "emoji"
          }, text];
        }
      };
    }
  }, {
    key: "rulePlugins",
    get: function get() {
      return [emoji_1.default];
    }
  }]);

  return Emoji;
}(Node_1.default);

exports.default = Emoji;